import { render, staticRenderFns } from "./BuscarCp.vue?vue&type=template&id=585ba7d8"
import script from "./BuscarCp.vue?vue&type=script&lang=js"
export * from "./BuscarCp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports